import { createAction } from 'redux-act';

import PlaceLocalization from '../../../models/interfaces/PlaceLocalization';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchPlaceLocalizationPayload extends FetchPayload {
  placeUuid: string;
}
export const fetchPlaceLocalization = createAction<FetchPlaceLocalizationPayload>('FETCH_PLACE_LOCALIZATION');

export interface PlaceLocalizationFetchedPayload extends TimestampPayload {
  placeLocalization: PlaceLocalization;
}
export const placeLocalizationFetched = createAction<PlaceLocalizationFetchedPayload>('PLACE_LOCALIZATION_FETCHED');

export interface PlaceLocalizationFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const placeLocalizationFetchFailed = createAction<PlaceLocalizationFetchFailedPayload>('PLACE_LOCALIZATION_FETCH_FAILED');
